/**
 * Email-click token (?tc=) kept for this tab until the visitor decides
 * (item 99). sessionStorage only, never sent anywhere before consent, and
 * cleared on Yes, on No, or 30 minutes after it was stored.
 */
export const PENDING_TC_KEY = "tango_pending_tc";
export const PENDING_TC_TTL_MS = 30 * 60 * 1000;
export const TC_FORMAT = /^[A-Za-z0-9_-]{20,64}$/;

interface Stored { t: string; at: number }

export function serialisePending(token: string, now: number): string {
  return JSON.stringify({ t: token, at: now } satisfies Stored);
}

export function parsePending(raw: string | null, now: number): string | null {
  if (!raw) return null;
  try {
    const p = JSON.parse(raw) as Stored;
    if (!p || typeof p.t !== "string" || typeof p.at !== "number") return null;
    if (!TC_FORMAT.test(p.t)) return null;
    if (now - p.at > PENDING_TC_TTL_MS || now < p.at) return null;
    return p.t;
  } catch {
    return null;
  }
}

export function storePending(token: string): void {
  try { sessionStorage.setItem(PENDING_TC_KEY, serialisePending(token, Date.now())); } catch { /* ignore */ }
}

export function loadPending(): string | null {
  try {
    const v = parsePending(sessionStorage.getItem(PENDING_TC_KEY), Date.now());
    if (!v) sessionStorage.removeItem(PENDING_TC_KEY);
    return v;
  } catch {
    return null;
  }
}

export function clearPending(): void {
  try { sessionStorage.removeItem(PENDING_TC_KEY); } catch { /* ignore */ }
}
